import React from 'react';
import { StateRowProps } from './types';

export const StateRow = ({
  state: { name, display_name, stateJobsPageUrl, topCities },
  seeAllText,
}: StateRowProps) => {
  return (
    <div className="state-card flex flex-col md:flex-row py-4 border-t border-kale">
      <div className="state-name flex lg:w-40 lg:basis-40 flex-shrink-0 font-medium">
        <h3 id={name}>{display_name}</h3>
        <span className="px-1" />
      </div>
      <div className="flex flex-wrap">
        {topCities.map((city, index) => {
          return (
            <a
              className="inline"
              key={`${index}-${city.slug}`}
              href={city.cityJobsPageUrl}
            >
              <p className="pr-2">{city.name}{index === topCities.length - 1 ? '' : ','}</p>
            </a>
          );
        })}
      </div>
      <a
        className="block mt-3 md:mt-0 md:ml-auto text-xs lg:text-sm font-medium whitespace-nowrap underline lg:no-underline"
        href={stateJobsPageUrl}
      >
        {seeAllText}
      </a>
    </div>
  );
};
